import Odometer from "odometer";
import * as React from "react";
import {findDOMNode} from "react-dom";

type Props = {
    value: number;
    duration?: number;
    theme?: string;
};

type DefaultProps = {
    duration: Props["duration"];
    theme: Props["theme"];
};

// Wraps odometer within a React component
class ReactOdometer extends React.Component<Props> {
    odometer: typeof Odometer;

    static defaultProps: DefaultProps = {
        duration: 3000,
        theme: "minimal",
    };

    componentDidMount() {
        this.odometer = new Odometer({
            // eslint-disable-next-line react/no-string-refs
            el: findDOMNode(this.refs["odometer-container"]),
            value: this.props.value,
            duration: this.props.duration,
            theme: this.props.theme,
        });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.duration !== this.props.duration) {
            this.odometer = new Odometer({
                // eslint-disable-next-line react/no-string-refs
                el: findDOMNode(this.refs["odometer-container"]),
                value: this.props.value,
                duration: this.props.duration,
                theme: this.props.theme,
            });
        }
        if (prevProps.value !== this.props.value) {
            this.odometer.update(this.props.value);
        }
    }

    render() {
        // eslint-disable-next-line react/no-string-refs
        return <span ref="odometer-container" />;
    }
}

export default ReactOdometer;
